import { Component, OnInit } from '@angular/core';
import { Router, RouterModule, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { UsuarioService } from '../../services/usuario.service';
import { CommonModule } from '@angular/common';
import { jwtDecode } from 'jwt-decode';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [RouterModule, CommonModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit {
  nomeUsuario: string = '';
  fotoUsuario: string | null = null;
  tipoNavbar: 'padrao' | 'exbeOn' | 'guardian' = 'padrao';

  constructor(
    private router: Router,
    private usuarioService: UsuarioService
  ) {}
  
  ngOnInit(): void {
    this.carregarDadosUsuario();

    this.verificarRota(this.router.url);

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.verificarRota(event.urlAfterRedirects);
    });
  }

  verificarRota(url: string): void {
    if (url.startsWith('/guardian')) {
      this.tipoNavbar = 'guardian';
    } else if (url.startsWith('/exbeOn')) {
      this.tipoNavbar = 'exbeOn';
    }
     else {
      this.tipoNavbar = 'padrao';
    }
  }

  private carregarDadosUsuario(): void {
    try {
      const token = this.getCookie("token");
      if (!token) return;

      const claims: any = this.decodeToken(token);
      this.nomeUsuario = claims.UsuarioNome || 'Usuário';
      const idUsuario = claims.UsuarioId;

      if (idUsuario) {
        this.usuarioService.obterFotoUsuario().subscribe({
          next: (response) => {
            this.fotoUsuario = response.fotoBase64;
          },
          error: () => {
            this.fotoUsuario = null;
          }
        });
      }
    } catch (error) {
      console.error('Erro ao carregar dados do usuário:', error);
      this.nomeUsuario = 'Usuário';
    }
  }

  private getCookie(name: string): string | null {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop()!.split(';').shift()!;
    return null;
  }

  private decodeToken(token: string): any {
    return jwtDecode(token);
  }

  Sair(): void {
    document.cookie = "token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    this.router.navigate(['/login']);
  }
}